import {
  Plugs,
  CursorClick,
  Brain,
  UsersThree,
  Palette,
  Calendar,
} from "@phosphor-icons/react";
import type { Icon } from "@phosphor-icons/react";
import { SectionArrow } from "./SectionArrow";
import { TOTAL_INTEGRATIONS } from "../../lib/integrations";

interface Feature {
  icon: Icon;
  title: string;
  description: string;
}

const features: Feature[] = [
  {
    icon: Plugs,
    title: `${TOTAL_INTEGRATIONS} Integrations`,
    description:
      "Connect Google Analytics, Meta Ads, LinkedIn, TikTok, and more. All your data in one place.",
  },
  {
    icon: CursorClick,
    title: "Drag-and-Drop Reports",
    description:
      "Build stunning client reports with our visual editor. No coding required.",
  },
  {
    icon: Brain,
    title: "AI-Powered Insights",
    description:
      "Get automatic narrative summaries and recommendations powered by AI.",
  },
  {
    icon: UsersThree,
    title: "Client Management",
    description:
      "Organize clients, manage team access, and track performance across your portfolio.",
  },
  {
    icon: Palette,
    title: "White-Label Branding",
    description:
      "Add your logo, colors, and custom domain. Reports look like they come from your agency.",
  },
  {
    icon: Calendar,
    title: "Scheduled Delivery",
    description:
      "Automate report delivery on your schedule. Email, PDF, or live dashboard links.",
  },
];

export function FeaturesSection() {
  return (
    <div id="features" className="pt-8 pb-12 sm:pt-12 sm:pb-14 scroll-mt-20">
      {/* px-6 on mobile keeps the feature cards off the screen edges; desktop sm:px-8. */}
      <div className="max-w-[1200px] mx-auto px-6 sm:px-8">
        <div className="text-center mb-12">
          <SectionArrow />
          <h2 className="text-2xl sm:text-3xl font-bold text-foreground">
            Everything you need to report smarter
          </h2>
          <p className="mt-4 text-lg text-foreground/85 max-w-[560px] mx-auto">
            ProvenLeap brings all your marketing data together.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature) => {
            return (
              <div
                key={feature.title}
                className="text-center px-6 py-8 bg-white shadow-xs rounded-[32px]"
                style={{ border: "0.5px solid var(--hairline)" }}
              >
                <div className="mb-4 flex justify-center">
                  <feature.icon size={22} className="text-foreground relative top-2" />
                </div>
                <h3 className="text-[19px] font-semibold text-foreground mb-2">
                  {feature.title}
                </h3>
                <p className="text-[16px] text-foreground/85 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
